<template>
    <div class="signBox">
        <breadcrumb :routerList="[{to:'/agent/agentCopy',title:'经销商管理'},{title:'经销商详情'}]"/>
        <div class="imgBox" v-loading="loading">
            <div class="bannerBox">
                <div class="whiteBox">
                    <div>
                        <div class="h-pieceTitle2" style="margin-bottom: 0;">
                            <h1>经销商类型</h1>
                        </div>
                        <el-radio-group v-model="radio" disabled @change="changeType" style="margin:20px 0 ;">
                            <el-radio-button label="国内客户"></el-radio-button>
<!--                            <el-radio-button label="上海直销"></el-radio-button>-->
                            <el-radio-button label="海外客户"></el-radio-button>
                        </el-radio-group>
                        <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;">
                            <h1>直单类型</h1>
                        </div>
                        <div style="margin-top: 5px;">
                            <span>
                            <el-switch
                                    disabled
                                    v-model="isZhiDan"
                                    class="zhidangc"
                                    active-text="是否是直单用户"
                                    style="margin-bottom: 0.2rem"
                                    inactive-text="">
                            </el-switch>
                            </span>
                            <span  v-if="this.agentType != '3'">
                                <el-switch
                                    style="margin-left: 50px;margin-bottom: 0.2rem"
                                    v-model="isExpandAuthority"
                                    active-text="是否开通海外下单权限"
                                    disabled>
                                </el-switch>
                            </span>
<!--                            <span v-if="this.agentType == '3'">
                                <el-switch
                                    style="margin-left: 50px;margin-bottom: 0.2rem"
                                    v-model="isExpandAuthority"
                                    active-text="是否开通国内下单权限"
                                    :disabled="this.flag==='2'||this.flag==='3'||this.flag==='4'">
                                </el-switch>
                            </span>-->
                            <!-- <span>
                                <el-switch
                                v-if="this.agentType != '3'"
                                style="margin-left: 50px;margin-bottom: 0.2rem"
                                @change="chooseIsBlood"
                                v-model="isBlood"
                                active-text="是否血站专用渠道"
                                inactive-text=""></el-switch>
                            </span> -->
                            <!-- <span v-else>
                                <el-switch
                                    style="margin-left: 50px;margin-bottom: 0.2rem"
                                    v-model="isExpandAuthority"
                                    active-text="是否开通海外下单权限"
                                    :disabled="this.flag==='2'||this.flag==='3'||this.flag==='4'">
                                </el-switch>
                            </span> -->
                        </div>
                        <!-- 直单：{{this.data.isExpandAuthorityBas}}
                        血站：{{this.data.isBloodBas}} -->
                        <div class="h-pieceTitle2" style="margin-bottom: 0;">
                            <h1>客户资质信息</h1>
                        </div>
                        <div class="signsign">
                            <div class="h-formLine" style="margin-top:0.38rem">
                                <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right"
                                        ref="formLabelAlign1c" :inline="true"
                                        :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                                    <el-form-item label="公司名称" class="h-elformWrap-2" prop="customerName1">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.customerName1"
                                                :title="formLabelAlign1.bscUserInfoAgentBasic.customerName1"
                                                placeholder="">
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="客户编码" class="h-elformWrap-2" prop="usercode">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.usercode"
                                                placeholder="">
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="客户" class="h-elformWrap-2" v-if="this.agentType != 3||agentType==3&&isExpandAuthority?true:false" prop="scale">
                                        <el-select disabled v-model="formLabelAlign1.bscUserInfoAgentBasic.scale"
												:class="{'ljjSelectdisabled':true}"
                                                placeholder="小规模经营者">
                                            <el-option label="小规模经营者" value="0"></el-option>
                                            <el-option label="一般纳税人" value="1"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="公司地址" class="h-elformWrap-2" prop="companyAddress">
                                        <el-input readonly
                                            v-model="formLabelAlign1.bscUserInfoAgentBasic.companyAddress"
                                            :title="formLabelAlign1.bscUserInfoAgentBasic.companyAddress"
                                            placeholder=""></el-input>
                                    </el-form-item>
                                    <el-form-item label="传真" class="h-elformWrap-2" prop="faxNumber"　v-if="this.agentType != 3||agentType==3&&isExpandAuthority?true:false">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.faxNumber"></el-input>
                                    </el-form-item>
                                    <el-form-item label="公司邮箱" class="h-elformWrap-2" prop="email">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.email"></el-input>
                                    </el-form-item>
                                    <el-form-item label="公司性质" class="h-elformWrap-2" v-if="this.agentType != 3||agentType==3&&isExpandAuthority?true:false" prop="companytype">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.companytype"
                                                placeholder=""></el-input>
                                    </el-form-item>
                                    <el-form-item label="成立时间" class="h-elformWrap-2" prop="founded">
                                        <el-date-picker
                                                disabled
                                                v-model="formLabelAlign1.bscUserInfoAgentBasic.founded"
                                                type="date"
												:class="{'ljjSelectdisabled':true}"
                                                placeholder="">
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item label="注册资金" class="h-elformWrap-2" prop="regmoney">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.regmoney"
                                                placeholder=""></el-input>
                                    </el-form-item>
                                    <el-form-item label="法人代表" class="h-elformWrap-2" prop="legal">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.legal"
                                                placeholder=""></el-input>
                                    </el-form-item>
                                    <el-form-item label="公司简介" class="h-elformWrap-2" prop="introduce">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.introduce"
                                                maxlength="70"
                                                placeholder=""></el-input>
                                    </el-form-item>
                                    <el-form-item label="主营业务" class="h-elformWrap-2" prop="business">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.business"
                                                placeholder=""></el-input>
                                    </el-form-item>
                                    <el-form-item label="年度营业规模(万元)" class="h-elformWrap-2" prop="achievement">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.achievement"
                                                placeholder=""></el-input>
                                    </el-form-item>
                                    <el-form-item label="主要用户资源" class="h-elformWrap-2" prop="resource">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.resource"
                                                placeholder=""></el-input>
                                    </el-form-item>
                                    <el-form-item label="联系人" class="h-elformWrap-2" prop="name1">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.name1"
                                                placeholder=""></el-input>
                                    </el-form-item>
                                    <el-form-item label="联系人手机号" class="h-elformWrap-2" prop="phoneNumber1">
                                        <el-input readonly
                                                v-model="formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone"
                                                placeholder=""></el-input>
                                    </el-form-item>
                                    <el-form-item label="所在国家" class="h-elformWrap-2" prop="country">
                                        <brselectlazy category="YLCountry_agent"
                                            :v="formLabelAlign1.bscUserInfoAgentBasic.country"
                                            v-model="formLabelAlign1.bscUserInfoAgentBasic.country"
                                            :class="{'ljjSelectdisabled':true}"
                                            :clearable="true" disabled/>
                                    </el-form-item>
                                    <el-form-item label="直销/分销" v-if="this.agentType == '3'" class="h-elformWrap-2" prop="isZhidan">
                                        <el-select disabled v-model="formLabelAlign1.bscUserInfoAgentBasic.isZhidan"
												:class="{'ljjSelectdisabled':true}"
                                                placeholder="">
                                            <el-option label="直销" value="1"></el-option>
                                            <el-option label="分销" value="0"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="所在地区" class="h-elformWrap-2" prop="region"
                                            v-show="this.isShowMassage === true ||agentType==3&&isExpandAuthority? true:false && this.agentType != '3'">
                                        <brselectlazy category="YLRegion"
                                            :v="formLabelAlign1.bscUserInfoAgentBasic.region"
                                            v-model="formLabelAlign1.bscUserInfoAgentBasic.region"
                                            :class="{'ljjSelectdisabled':true}"
                                            :clearable="true" disabled/>
                                    </el-form-item>
                                    <el-form-item label="所在城市" class="h-elformWrap-2" prop="companyAddress"  v-show="this.isShowMassage === true ||agentType==3&&isExpandAuthority? true:false && this.agentType != '3'">
                                        <el-select
                                                filterable
                                                disabled
												:class="{'ljjSelectdisabled':true}"
                                                v-model="formLabelAlign1.bscUserInfoAgentBasic.contactCity"
                                                placeholder="">
                                            <el-option v-for="(item,index) in addli" :key="index" :label="item" :value="item">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <!-- <el-form-item label="备注" v-if="this.agentType == '3'" class="h-elformWrap-2">
                                        <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.remark"
                                            readonly placeholder=""></el-input>
                                    </el-form-item> -->
                                </el-form>
                            </div>
                        </div>
                        <div class="h-pieceTitle2" style="margin-bottom: 0;">
                            <h1>开票信息</h1>
                            <span style="font-size: 14px;color: #a8a8a8;margin-left:19px;">凡是贵公司相关信息的变更请及时通知，以便及时调整，保证开票信息无误</span>
                        </div>
                        <div class="signsign">
                            <div class="h-formLine" style="margin-top:0.38rem">
                                <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right"
                                        ref="formLabelAlign1d" :inline="true"
                                        :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                                    <el-form-item label="客户名称" class="h-elformWrap-2" prop=customerName1>
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.customerName1"
                                            :title="formLabelAlign1.bscUserInfoAgentBasic.customerName1"
                                            placeholder=""></el-input>
                                    </el-form-item>
                                    <el-form-item label="纳税人登记号" class="h-elformWrap-2" prop="taxCode"
                                                v-show="this.agentType===1||this.agentType===2">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.taxCode"
                                                placeholder=""></el-input>
                                    </el-form-item>
                                    <el-form-item label="开票地址" class="h-elformWrap-2" prop="cityStreetRoom">
                                        <el-input clearable readonly
                                                :title="formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom"
                                                v-model="formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom">
                                        </el-input>
                                        <areaSelect :visible.sync="showflag" @choseObj="choseObj" title="选择地址"
                                                    v-if="showflag"
                                                    v-model="formLabelAlign1.bscUserInfoAgentCompany.mailaddress"
                                                    readonly/>
                                    </el-form-item>
                                    <el-form-item label="公司电话" class="h-elformWrap-2" prop="phoneNumber">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.phoneNumber"
                                                placeholder=""></el-input>
                                    </el-form-item>
                                    <!-- <el-form-item label="联系人" class="h-elformWrap-2" prop="name1">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.name1"
                                                placeholder=""></el-input>
                                    </el-form-item> -->

                                </el-form>
                                                                    <el-form :model="formLabelAlign1.bscUserInfoAgentBank" label-position="right"
                                            ref="formLabelAlign1e" :inline="true"
                                            :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                                        <el-form-item label="银行编号" class="h-elformWrap-2" prop="bankBranchCode">
                                            <el-input readonly
                                                v-model="formLabelAlign1.bscUserInfoAgentBank.bankBranchCode"
                                                onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                                                placeholder=""></el-input>
                                        </el-form-item>
                                        <el-form-item label="银行名称" class="h-elformWrap-2" prop="bankName">
                                            <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBank.bankName"
                                                :title="formLabelAlign1.bscUserInfoAgentBank.bankName"
                                                placeholder=""></el-input>
                                        </el-form-item>
                                        <el-form-item label="银行账户号" class="h-elformWrap-2" prop="accountHolderName">
                                            <el-input readonly
                                                v-model="formLabelAlign1.bscUserInfoAgentBank.accountHolderName"
                                                placeholder=""></el-input>
                                        </el-form-item>
                                        <el-form-item label="银行所属国家" class="h-elformWrap-2" prop="bankCountry">
                                            <brselectlazy category="YLCountry_agent"
                                                :v="formLabelAlign1.bscUserInfoAgentBank.bankCountry"
                                                v-model="formLabelAlign1.bscUserInfoAgentBank.bankCountry"
                                                :class="{'ljjSelectdisabled':true}"
                                                :clearable="true" disabled/>
                                        </el-form-item>
                                    </el-form>
                                    <el-form :model="formLabelAlign1.bscUserInfoAgentSell" label-position="right"
                                        ref="formLabelAlign1f" :inline="true"
                                        :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                                        <el-form-item label="发票类型" class="h-elformWrap-2" prop="customerGroup1">
                                            <el-select disabled placeholder=""
														:class="{'ljjSelectdisabled':true}"
                                                    v-model="formLabelAlign1.bscUserInfoAgentSell.customerGroup1">
                                                  <el-option label="增值税发票" value="01"></el-option>
                                                  <el-option label="普通发票" value="02"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <!-- 国际贸易条件  补充判断条件  下单条件等于 1 -->
                                        <el-form-item label="国际贸易条件" class="h-elformWrap-2" prop="intCommercialTerms"
                                                v-if="this.agentType == '3' || this.isExpandAuthority == true ">
                                            <brselectlazy category="YlCommercialTerms" :showcode="true"
                                                    :v="formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms"
                                                    v-model="formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms"
                                                    disabled
                                                    :class="{'ljjSelectdisabled':true}"
                                                    :clearable="flase"/>
                                        </el-form-item>
                                        <el-form-item label="国际贸易条件2" class="h-elformWrap-2" prop="intCommercialTerms2"
                                                    v-if="this.agentType == '3'|| this.isExpandAuthority == true ">
                                            <brselectlazy category="YlCommercialTerms" :showcode="true"
                                                    :v="formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2"
                                                    v-model="formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2"
                                                    :class="{'ljjSelectdisabled':true}"
                                                    disabled
                                                    :clearable="flase"/>
                                        </el-form-item>
                                        <el-form-item label="货币种类" class="h-elformWrap-2" prop="currencyCode">
                                            <brselectlazy category="YLCurrency"
                                                    :v="formLabelAlign1.bscUserInfoAgentSell.currencyCode"
                                                    :class="{'ljjSelectdisabled':true}"
                                                    v-model="formLabelAlign1.bscUserInfoAgentSell.currencyCode"
                                                    :clearable="true" style="width:2.33rem" disabled/>
                                        </el-form-item>
                                    </el-form>

                            </div>
                        </div>
                        <div class="h-pieceTitle2" style="margin-bottom: 0;" v-if="agentType!=3||agentType==3&&isExpandAuthority?true:false">
                            <h1>邮寄发票信息</h1>
                        </div>
                        <div class="signsign" v-if="agentType!=3||agentType==3&&isExpandAuthority?true:false">
                            <div class="h-formLine" style="margin-top:0.38rem">
                                <el-form :model="formLabelAlign1.bscUserInfoAgentCompany" label-position="right"
                                        ref="formLabelAlign1h" :inline="true"
                                        :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                                    <el-form-item label="邮寄接收人" class="h-elformWrap-2" prop="mailreceiver">
                                        <el-input readonly
                                            v-model="formLabelAlign1.bscUserInfoAgentCompany.mailreceiver"
                                            placeholder=""></el-input>
                                    </el-form-item>
                                    <el-form-item label="电话" class="h-elformWrap-2" prop="receiverphone">
                                        <el-input readonly
                                                v-model="formLabelAlign1.bscUserInfoAgentCompany.receiverphone"
                                                placeholder=""></el-input>
                                    </el-form-item>
                                    <el-form-item label="选择邮寄地址" class="h-elformWrap-2" prop="mailaddress">
                                        <el-input clearable readonly
                                            :title="formLabelAlign1.bscUserInfoAgentCompany.mailaddress"
                                            v-model="formLabelAlign1.bscUserInfoAgentCompany.mailaddress">
                                        </el-input>
                                        <areaSelect :visible.sync="showflag" @choseObj="choseObj" title="选择地址"
                                                    v-if="showflag"
                                                    v-model="formLabelAlign1.bscUserInfoAgentCompany.mailaddress"
                                                    readonly/>
                                    </el-form-item>
                                </el-form>

                            </div>
                        </div>
                        <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;">
                            <h1>上传附件</h1>
                        </div>
                        <div class="h-formLine weekplandetail11">
                            <el-form :model="formLabelAlign1.bscUserInfoAgentCompany" label-position="right"
                                    ref="formLabelAlign1i" :inline="true"
                                    :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                                <el-form-item label="企业营业执照" class="h-elformWrap-2" prop="upload"
                                              v-if="this.agentType != '3' || (this.agentType == '3' && this.isExpandAuthority == true)">
                                    <brupload v-if="fileShowFlag" :refid="refid" reftype="代理商注册-企业营业执照"
                                            :uploadflag="uploadflag" :delflag="delflag"
                                            :showtime="showtime">
                                    </brupload>
                                </el-form-item>
                                <el-form-item label="银行开户证明" class="h-elformWrap-2" prop="upload"
                                              v-if="this.agentType != '3' || (this.agentType == '3' && this.isExpandAuthority == true)">
                                    <brupload v-if="fileShowFlag" :refid="refid" reftype="代理商注册-银行开户证明"
                                            :uploadflag="uploadflag" :delflag="delflag"
                                            :showtime="showtime">
                                    </brupload>
                                </el-form-item>
                              <el-form-item label="企业营业执照有效截止日期" class="h-elformWrap-2" prop="yyzzEffectiveDate"
                                            v-if="this.agentType != '3' || (this.agentType == '3' && this.isExpandAuthority == true)">
                                <el-date-picker
                                    style="width: 180px" v-if="fileShowFlag" disabled
                                    v-model="formLabelAlign1.bscUserInfoAgentSell.yyzzEffectiveDate"
                                    type="date"
                                    placeholder="选择日期">
                                </el-date-picker>
                              </el-form-item>
                                <el-form-item label="法人身份证" class="h-elformWrap-2" prop="upload"
                                              v-if="this.agentType != '3' || (this.agentType == '3' && this.isExpandAuthority == true)">
                                    <brupload v-if="fileShowFlag" :refid="refid" reftype="代理商注册-法人身份证"
                                            :uploadflag="uploadflag" :delflag="delflag"
                                            :showtime="showtime">
                                    </brupload>
                                </el-form-item>
                                <el-form-item label="一般纳税人提供相关资质证明" class="h-elformWrap-2" prop="upload"
                                              v-if="this.agentType != '3' || (this.agentType == '3' && this.isExpandAuthority == true)">
                                    <brupload v-if="fileShowFlag" :refid="refid" reftype="代理商注册-一般纳税人提供相关资质证明"
                                            :uploadflag="uploadflag" :delflag="delflag"
                                            :showtime="showtime">
                                    </brupload>
                                </el-form-item>
                                <el-form-item label="名称修改见证性资料" class="h-elformWrap-2" prop="upload">
                                    <brupload
                                            :refid="refid"
                                            reftype="代理商修改名称-见证性资料"
                                            :uploadflag="uploadflag"
                                            :delflag="delflag"
                                            :showtime="false">
                                    </brupload>
                                </el-form-item>
                                <el-form-item label="发票类型见证性资料" class="h-elformWrap-2" prop="upload">
                                    <brupload
                                            :refid="refid"
                                            reftype="代理商修改发票-见证性资料"
                                            :uploadflag="uploadflag"
                                            :delflag="delflag"
                                            :showtime="false">
                                    </brupload>
                                </el-form-item>
                                <el-form-item label="" class="h-elformWrap-2" style="margin-left: 1.7rem;width: 45%;" v-if="this.agentType != '3'">
                                    <el-switch disabled v-model="have2" active-text="" inactive-text="是否有二级资质证书">
                                    </el-switch>
                                </el-form-item>
                                <el-form-item label="" class="h-elformWrap-2" style="width: 43%;padding-right: 0;padding-left: 0.8rem;" v-if="this.agentType != '3'">
                                    <el-switch disabled v-model="have3" active-text="" inactive-text="是否有三级资质证书">
                                    </el-switch>
                                </el-form-item>
                                <el-form-item label="二类经营许可证" class="h-elformWrap-2" prop="upload"
                                              v-show="have2 && (this.agentType != '3' || (this.agentType == '3' && this.isExpandAuthority == true))">
                                    <brupload v-if="fileShowFlag" :refid="refid" reftype="代理商注册-二类经营许可证"
                                            :uploadflag="uploadflag" :delflag="delflag"
                                            :showtime="showtime">
                                    </brupload>
                                </el-form-item>
                                <el-form-item label="委托汇款的附件" class="h-elformWrap-2" v-if="this.agentType == '3'||agentType != 3 && isExpandAuthority">
                                    <brupload
                                            v-if="fileShowFlag"
                                            :refid="refid"
                                            reftype="代理商注册-委托汇款的附件"
                                            :uploadflag="uploadflag"
                                            :delflag="delflag"
                                            :showtime="false">
                                    </brupload>
                                </el-form-item>
                                <el-form-item label="许可证有效截止日期" class="h-elformWrap-2" prop="xkzEffectiveDate"  v-if="this.haveThree6840 == true">
                                  <el-date-picker
                                      style="width: 180px" disabled
                                      v-model="formLabelAlign1.bscUserInfoAgentSell.xkzEffectiveDate"
                                      type="date"
                                      placeholder="选择日期">
                                  </el-date-picker>
                                </el-form-item>
                                <el-form-item style="padding-right:0;width: 90%;" label="" class="h-elformWrap-2"
                                              v-if="this.agentType != '3' || (this.agentType == '3' && this.isExpandAuthority == true)">
                                    <div style="display:flex;align-items: center;width: 40.2rem;margin-left: 0.4rem;">
                                        <el-switch disabled
                                                   style="margin-left: 0.3rem;"
                                                   v-model="have6858"
                                                   active-text=""
                                                   inactive-text="是否包含6858">
                                        </el-switch>
                                        <el-switch disabled
                                                   style="margin-left: 0.3rem;"
                                                   v-model="have6840"
                                                   active-text=""
                                                   inactive-text="是否包含6840">
                                        </el-switch>
                                        <el-switch disabled
                                                   style="margin-left: 0.3rem;"
                                                   v-model="have3"
                                                   active-text=""
                                                   inactive-text="是否有许可证">
                                        </el-switch>
                                    </div>
                                </el-form-item>
                                <el-form-item label="三类经营许可证" class="h-elformWrap-2" prop="upload" v-show="have3"
                                              v-if="this.agentType != '3' || (this.agentType == '3' && this.isExpandAuthority == true)">
                                    <div style="display: flex;align-items: center;width: 40.2rem;margin-left: 0.4rem;">
                                        <brupload v-if="fileShowFlag" :refid="refid" reftype="代理商注册-三类经营许可证"
                                                  :uploadflag="uploadflag" :delflag="delflag"
                                                  :showtime="showtime">
                                        </brupload>
                                        <el-switch
                                                :disabled="this.flag==='2'||this.flag==='3'||this.flag==='4'"
                                                style="margin-left: 3.2rem;"
                                                v-model="have6854"
                                                active-text=""
                                                inactive-text="是否包含6854">
                                        </el-switch>
                                    </div>
                                </el-form-item>
                                <el-form-item label="" class="h-elformWrap-2" v-if="this.agentType != '3'">
                                    <el-switch disabled style="margin-left: 2.1rem;width: 2rem;" v-model="have6854"
                                            active-text="" inactive-text="是否包含6854">
                                    </el-switch>
                                </el-form-item>
                                <!--  补充  包含III类6840(体外诊断试剂 -->
                                <el-form-item class="h-elformWrap-2"  v-if="this.agentType != '3' || (this.agentType == '3' && this.isExpandAuthority == true)">
                                    <el-switch
                                        disabled
                                        v-model="haveThree6840"
                                        @change="chooseIVD"
                                        inactive-text="是否包含III类6840(体外诊断试剂)">
                                    </el-switch>
                                </el-form-item>
                                <el-form-item label="三类经营许可证" class="h-elformWrap-2" v-if="this.haveThree6840 == true"
                                    :prop="formLabelAlign1.bscUserInfoAgentSell.haveThree6840 == true? 'upload8': '' ">
                                    <brupload
                                            v-if="fileShowFlag"
                                            :refid="refid"
                                            reftype="三类6840经营许可证"
                                            :uploadflag="uploadflag"
                                            :delflag="delflag"
                                            :showtime="false">
                                    </brupload>

                                </el-form-item>
                            </el-form>
                            <el-form :model="formLabelAlign1.bscUserInfoAgentSell" label-position="right"
                                ref="formLabelAlign1i" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                                <el-form-item label="许可证号" class="h-elformWrap-2"  v-if="this.haveThree6840 == true"
                                    :prop="this.haveThree6840 == true? 'licenseNumber': '' " >
                                    <el-input v-model="formLabelAlign1.bscUserInfoAgentSell.licenseNumber"  disabled
                                        placeholder="请输入许可证号" >
                                    </el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>

                    <div>
                        <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;">
                            <h1>资质审核</h1>
                        </div>
                        <div class="signsign">
                            <div class="h-formLine" style="margin-top:0.38rem">
                                <el-form :model="formLabelAlign1.bscUserInfoAgentSell" label-position="right"
                                         ref="formLabelAlign11"
                                         :inline="true" :rules="rules1" class="demo-ruleForm h-formbLine h-formbLine1">

                                  <el-form-item label="  经销商类别" class="h-elformWrap-2" prop="agentLevel" style="margin-left: 0.3rem;">
                                    <div style="display: flex;margin-left: 0.2rem;">
                                      <brselect category="DealerCategory_type" v-model="formLabelAlign1.bscUserInfoAgentBasic.agentLevel"
                                                :v="formLabelAlign1.bscUserInfoAgentBasic.agentLevel"
                                                  disabled
                                                  style="width: 1.5rem!important;margin-left: 0.2rem;"
                                                  placeholder="请选择">
                                      </brselect>
                                    </div>
                                  </el-form-item>

                                  <el-form-item label="一级经销商" class="h-elformWrap-2" prop="oneLevelAgentName" v-if="formLabelAlign1.bscUserInfoAgentBasic.agentLevel==2">
                                    <el-select v-model="formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgentName" :title="formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgentName" remote filterable :filter-method="showAgentList" clearable  placeholder="请输入"
                                               disabled
                                    >
                                      <el-option v-for="(item) in oneAgentList"
                                                 :key="item.customerName"
                                                 :label="item.customerName"
                                                 :value="item">
                                      </el-option>
                                    </el-select>
                                  </el-form-item>

                                  <el-form-item label="合同号" class="h-elformWrap-2" prop="contractId">
                                    <el-input
                                        :title="formLabelAlign1.bscUserInfoAgentBasic.contractId"
                                        disabled
                                        v-model="formLabelAlign1.bscUserInfoAgentBasic.contractId"
                                        placeholder="请填写"></el-input>
                                  </el-form-item>

                                  <el-form-item label="链群" class="h-elformWrap-3" prop="goodsCategory" v-if="this.agentType!=3" style="margin-left: -0.5rem;">
<!--                                    <item style="float: left">传统(</item>
                                    <el-checkbox-group v-model="lianqunList"  style="float: left;margin-left: 10px;margin-right: 10px"  disabled>
                                      <el-checkbox label="X02">样本网</el-checkbox>
                                      <el-checkbox label="X01" >药品网</el-checkbox>
                                      <el-checkbox label="X08" >生物安全类</el-checkbox>
                                      <el-checkbox label="X09" >培养箱类</el-checkbox>
                                      <el-checkbox label="X10" >离心机</el-checkbox>
&lt;!&ndash;                                      <el-checkbox label="X07" >试剂网</el-checkbox>&ndash;&gt;
                                    </el-checkbox-group>
                                    <item style="float: left">)</item>-->
                                    <el-checkbox-group v-model="lianqunListCt" @change="getLianqunTickct"  style="float: left;margin-left: 10px;margin-right: 10px">
                                      <el-checkbox label="ct">传统产品</el-checkbox>
                                    </el-checkbox-group>
                                    <el-checkbox-group v-model="lianqunList"   style="float: left;margin-left: 10px;margin-right: 10px"  disabled>
                                      <el-checkbox label="X05">血液网</el-checkbox>
                                      <el-checkbox  label="X06">疫苗网</el-checkbox>
                                      <el-checkbox  label="X12">航空温控</el-checkbox>
                                    </el-checkbox-group>
                                  </el-form-item>

                                    <el-form-item label="" class="h-elformWrap-1" prop="scale">
                                      <div v-if="this.agentType == 2"  style="margin-bottom:-30px"  >
                                        <!--                          传统产品-->
                                        <el-form-item label="" class="h-elformWrap-1" prop="scale" v-if="isCt" style="margin-left: -0.1rem;width: 100%;margin-top: -0.3rem">
                                          <!--                                        循环-->
                                          <div v-for="(listIt, index) in formLabelAlign1.ctList" :key="index">
                                            <div style="display: flex;flex-wrap: wrap;margin-top: 0.1rem;margin-bottom: 0.1rem">

                                              <item style="float: left;margin-left: 0.9rem;color: #4a4a4a;">链群 传统(</item>
                                              <el-checkbox-group v-model="formLabelAlign1.ctList[index].lianqunList"  :v="formLabelAlign1.ctList[index].lianqunList" style="float: left;margin-left: 10px;margin-right: 10px"
                                                                 disabled
                                              >
                                                <el-checkbox label="X02">样本网</el-checkbox>
                                                <el-checkbox label="X01" >药品网</el-checkbox>
                                                <el-checkbox label="X08" >生物安全类</el-checkbox>
                                                <el-checkbox label="X09" >培养箱类</el-checkbox>
                                                <el-checkbox label="X10" >离心机</el-checkbox>
                                                <el-checkbox label="X11" >危化品</el-checkbox>
                                              </el-checkbox-group>
                                              <item style="float: left">)</item>
                                            </div>
                                            <div style="display: flex;flex-wrap: wrap;margin-top: 0.1rem;margin-bottom: 0.1rem;width: 110%">
                                              <div style="font-size: 0.18rem;color: #4a4a4a;line-height: 0.28rem;margin-left: 0.9rem;">
                                                传统产品
                                              </div>
                                              <div style="display: flex;margin-left: 0.4rem;">
                                                <div class="foundation-box">
                                                  领域:
                                                </div>
                                                <el-select v-if="ct" v-model="formLabelAlign1.ctList[index].field" @change="fieldSelect(index)" disabled
                                                           style="width: 1.5rem!important;margin-left: 0.2rem;"
                                                           placeholder="请选择">
                                                  <el-option v-for="item in fieldList"
                                                             :key="item.index"
                                                             :value="item.code"
                                                             :label="item.name"
                                                             :disabled="hasIncludeField(fields,item.code)"
                                                  ></el-option>
                                                </el-select>
                                              </div>

                                              <div style="display: flex;margin-left: 0.4rem;">
                                                <div class="qudoa" :class="{'gccolor':formLabelAlign1.ctList[index].cheakChannel}">
                                                  渠道:
                                                </div>
                                                <brselectlazy :multiple="true" category="sales_region" disabled  style="width: 4.5rem"
                                                              :v="formLabelAlign1.ctList[index].channel"
                                                              v-model="formLabelAlign1.ctList[index].channel"
                                                              :class="{'ljjSelectdisabled':true}"
                                                              :clearable="true"/>
                                              </div>

                                              <div style="display: flex;margin-left: 0.4rem;">
                                                <div class="foundation-box" :class="{'gccolor':formLabelAlign1.ctList[index].cheakLevel}">
                                                  产品价格:
                                                </div>
                                                <el-select v-if="ct && isZhiDan!=1" v-model="formLabelAlign1.ctList[index].level" @change="ctSelect" disabled
                                                           style="width: 1.5rem!important;margin-left: 0.2rem;"
                                                           placeholder="请选择">
                                                  <el-option label="未签约" value=""></el-option>
                                                  <el-option label="一级产品价格" value="01"></el-option>
                                                  <el-option label="二级产品价格" value="02"></el-option>
                                                  <el-option label="三级产品价格" value="03"></el-option>
                                                  <!--                                                    <el-option label="直单价格" value="06"></el-option>-->
                                                  <el-option label="分销商价格" value="05" v-if="formLabelAlign1.bscUserInfoAgentBasic.agentLevel != '1'"></el-option>
                                                </el-select>
                                                <el-select v-if="ct && isZhiDan==1" v-model="formLabelAlign1.ctList[index].level" @change="ctSelect" disabled
                                                           style="width: 1.5rem!important;margin-left: 0.2rem;"
                                                           placeholder="请选择">
                                                  <el-option label="未签约" value=""></el-option>
                                                  <el-option label="直单价格" value="04"></el-option>
                                                </el-select>
                                              </div>
                                            </div>
                                          </div>
                                        </el-form-item>
                                        <!--                          血液-->
                                        <el-form-item label="" class="h-elformWrap-1" prop="scale" v-if="isND5" style="margin-left: -0.1rem;width: 100%;margin-top: -0.4rem;width: 110%">
                                          <!--                                        循环-->
                                          <div v-for="(listIt, index) in formLabelAlign1.ND5List" :key="index">
                                            <div style="display: flex;flex-wrap: wrap;margin-top: 0.1rem;margin-bottom: 0.1rem">
                                              <div style="font-size: 0.18rem;color: #4a4a4a;line-height: 0.28rem;margin-left: 0.9rem;">
                                                U血液
                                              </div>

                                              <el-switch
                                                  v-if="agentType != '3' && index == 0"
                                                  disabled
                                                  style="margin-left: 30px;"
                                                  v-model="isBlood"
                                                  active-text="是否血站专用渠道"
                                                  inactive-text=""></el-switch>
                                              <div style="display: flex;margin-left: 2.5rem;" v-if="index == 1">
                                                <div class="foundation-box">
                                                </div>
                                              </div>

                                              <div style="display: flex;margin-left: 0.64rem;">
                                                <div class="qudoa" :class="{'gccolor':formLabelAlign1.ND5List[index].cheakChannel}">
                                                  渠道:
                                                </div>
                                                <brselectlazy :multiple="true" category="sales_region" disabled  style="width: 4.5rem"
                                                              :v="formLabelAlign1.ND5List[index].channel"
                                                              v-model="formLabelAlign1.ND5List[index].channel"
                                                              :class="{'ljjSelectdisabled':true}"
                                                              :clearable="true"/>
                                              </div>

                                              <div style="display: flex;margin-left: 0.4rem;" >
                                                <div class="foundation-box" :class="{'gccolor':formLabelAlign1.ND5List[index].cheakLevel}">
                                                  产品价格:
                                                </div>
                                                <el-select v-if="ct && isZhiDan!=1" v-model="formLabelAlign1.ND5List[index].level" @change="ND4Select" disabled
                                                           style="width: 1.5rem!important;margin-left: 0.2rem;"
                                                           placeholder="请选择">
                                                  <el-option label="未签约" value=""></el-option>
                                                  <el-option label="一级产品价格" value="01"></el-option>
                                                  <el-option label="二级产品价格" value="02"></el-option>
                                                  <el-option label="三级产品价格" value="03"></el-option>
                                                  <!--                                                    <el-option label="直单价格" value="06"></el-option>-->
                                                  <el-option label="分销商价格" value="05" v-if="formLabelAlign1.bscUserInfoAgentBasic.agentLevel != '1'"></el-option>
                                                </el-select>
                                                <el-select v-if="ct && isZhiDan==1" v-model="formLabelAlign1.ND5List[index].level" @change="ND4Select"
                                                           style="width: 1.5rem!important;margin-left: 0.2rem;"
                                                           placeholder="请选择">
                                                  <el-option label="未签约" value=""></el-option>
                                                  <el-option label="直单价格" value="04"></el-option>
                                                </el-select>
                                              </div>
                                            </div>
                                          </div>
                                        </el-form-item>
                                        <!--                              疫苗-->

                                        <el-form-item label="" class="h-elformWrap-1" prop="scale" v-if="isND4" style="margin-left: -0.1rem;width: 100%;margin-top: -0.4rem">
                                          <div style="display: flex;flex-wrap: wrap;margin-top: 0.1rem;margin-bottom: 0.1rem">
                                            <div style="font-size: 0.18rem;color: #4a4a4a;line-height: 0.28rem;margin-left: 0.9rem;">
                                              U疫苗
                                            </div>

                                            <div style="display: flex;margin-left: 2.5rem;">
                                              <div class="foundation-box">
                                              </div>
                                            </div>

                                            <div style="display: flex;margin-left: 0.64rem;">
                                              <div class="qudoa" :class="{'gccolor':formLabelAlign1.cheakNA4Level}">
                                                渠道:
                                              </div>
                                              <brselectlazy :multiple="true" category="sales_region" disabled  style="width: 4.5rem"
                                                            :v="formLabelAlign1.ND4Channel"
                                                            v-model="formLabelAlign1.ND4Channel"
                                                            :class="{'ljjSelectdisabled':true}"
                                                            :clearable="true"/>
                                            </div>

                                            <div style="display: flex;margin-left: 0.4rem;">
                                              <div class="foundation-box" :class="{'gccolor':hND4}">
                                                产品价格:
                                              </div>
                                              <el-select v-if="ct && isZhiDan!=1" v-model="ND4Level" @change="ND4Select" disabled
                                                         style="width: 1.5rem!important;margin-left: 0.2rem;"
                                                         placeholder="请选择">
                                                <el-option label="未签约" value=""></el-option>
                                                <el-option label="一级产品价格" value="01"></el-option>
                                                <el-option label="二级产品价格" value="02"></el-option>
                                                <el-option label="三级产品价格" value="03"></el-option>
                                                <!--                                                    <el-option label="直单价格" value="06"></el-option>-->
                                                <el-option label="分销商价格" value="05" v-if="formLabelAlign1.bscUserInfoAgentBasic.agentLevel != '1'"></el-option>
                                              </el-select>
                                              <el-select v-if="ct && isZhiDan==1" v-model="ND4Level" @change="ND4Select"
                                                         style="width: 1.5rem!important;margin-left: 0.2rem;"
                                                         placeholder="请选择">
                                                <el-option label="未签约" value=""></el-option>
                                                <el-option label="直单价格" value="04"></el-option>
                                              </el-select>
                                            </div>
                                          </div>
                                        </el-form-item>
                                        <!--                            航空温控-->
                                        <el-form-item label="" class="h-elformWrap-1" prop="scale" v-if="isNA9" style="margin-left: -0.1rem;width: 100%;margin-top: -0.4rem">
                                          <div style="display: flex;flex-wrap: wrap;margin-top: 0.1rem;margin-bottom: 0.1rem">
                                            <div style="font-size: 0.18rem;color: #4a4a4a;line-height: 0.28rem;margin-left: 0.9rem;">
                                              航空温控
                                            </div>

                                            <div style="display: flex;margin-left: 2.3rem;">
                                              <div class="foundation-box">
                                              </div>
                                            </div>

                                            <div style="display: flex;margin-left: 0.64rem;">
                                              <div class="qudoa" :class="{'gccolor':formLabelAlign1.cheakNA9Level}">
                                                渠道:
                                              </div>
                                              <brselectlazy :multiple="true" category="sales_region" disabled  style="width: 4.5rem"
                                                            :v="formLabelAlign1.NA9Channel"
                                                            v-model="formLabelAlign1.NA9Channel"
                                                            :class="{'ljjSelectdisabled':true}"
                                                            :clearable="true"/>
                                            </div>

                                            <div style="display: flex;margin-left: 0.4rem;">
                                              <div class="foundation-box"  :class="{'gccolor':hNA9}">
                                                产品价格:
                                              </div>
                                              <el-select v-if="ct && isZhiDan!=1" v-model="NA9Level" @change="NA9Select" disabled
                                                         style="width: 1.5rem!important;margin-left: 0.2rem;"
                                                         placeholder="请选择">
                                                <el-option label="未签约" value=""></el-option>
                                                <el-option label="一级产品价格" value="01"></el-option>
                                                <el-option label="二级产品价格" value="02"></el-option>
                                                <el-option label="三级产品价格" value="03"></el-option>
                                                <!--                                                    <el-option label="直单价格" value="06"></el-option>-->
                                                <el-option label="分销商价格" value="05" v-if="formLabelAlign1.bscUserInfoAgentBasic.agentLevel != '1'"></el-option>
                                              </el-select>
                                              <el-select v-if="ct && isZhiDan==1" v-model="NA9Level" @change="NA9Select"
                                                         style="width: 1.5rem!important;margin-left: 0.2rem;"
                                                         placeholder="请选择">
                                                <el-option label="未签约" value=""></el-option>
                                                <el-option label="直单价格" value="04"></el-option>
                                              </el-select>
                                            </div>
                                          </div>
                                        </el-form-item>

                                      </div>

                                      <div v-if="this.agentType == 3">
                                        <div style="display: flex;">
                                          <div style="font-size: 0.18rem;color: #4a4a4a;line-height: 0.28rem;margin-left: 0.9rem;">
                                            产品价格
                                          </div>
                                          <div style="display: flex;margin-left: 0.7rem;">
                                            <div style="font-size: 0.18rem;color: #868686;line-height: 0.28rem;">
                                              传统产品:
                                            </div>
                                            <el-select disabled placeholder=""
                                                       :class="{'ljjSelectdisabled':true}"
                                                       style="width: 1.5rem!important;margin-left: 0.2rem;"
                                                       v-model="ctLevel">
                                              <el-option label="未签约" value=""></el-option>
                                              <el-option label="一级经销商" value="01"></el-option>
                                              <el-option label="二级经销商" value="02"></el-option>
                                              <el-option label="三级经销商" value="03"></el-option>
                                              <!--                                                  <el-option label="直单价格" value="06"></el-option>-->
                                              <el-option label="分销商价格" value="05"></el-option>
                                            </el-select>
                                          </div>
                                          <div style="display: flex;margin-left: 0.7rem;">
                                            <div style="font-size: 0.18rem;color: #868686;line-height: 0.28rem;">
                                              U血液:
                                            </div>
                                            <el-select disabled placeholder=""
                                                       :class="{'ljjSelectdisabled':true}"
                                                       style="width: 1.5rem!important;margin-left: 0.2rem;"
                                                       v-model="ND5Level">
                                              <el-option label="未签约" value=""></el-option>
                                              <el-option label="一级产品价格" value="01"></el-option>
                                              <el-option label="二级产品价格" value="02"></el-option>
                                              <el-option label="三级产品价格" value="03"></el-option>
                                              <el-option label="分销商价格" value="05"></el-option>
                                            </el-select>
                                          </div>
                                          <div style="display: flex;margin-left: 0.7rem;">
                                            <div style="font-size: 0.18rem;color: #868686;line-height: 0.28rem;">
                                              U疫苗:
                                            </div>
                                            <el-select disabled placeholder=""
                                                       :class="{'ljjSelectdisabled':true}"
                                                       style="width: 1.5rem!important;margin-left: 0.2rem;"
                                                       v-model="ND4Level">
                                              <el-option label="未签约" value=""></el-option>
                                              <el-option label="一级产品价格" value="01"></el-option>
                                              <el-option label="二级产品价格" value="02"></el-option>
                                              <el-option label="三级产品价格" value="03"></el-option>
                                              <el-option label="分销商价格" value="05"></el-option>
                                            </el-select>
                                          </div>
                                          <div style="display: flex;margin-left: 0.7rem;">
                                            <div style="font-size: 0.18rem;color: #868686;line-height: 0.28rem;">
                                              航空温控:
                                            </div>
                                            <el-select disabled placeholder=""
                                                       :class="{'ljjSelectdisabled':true}"
                                                       style="width: 1.5rem!important;margin-left: 0.2rem;"
                                                       v-model="NA9Level">
                                              <el-option label="未签约" value=""></el-option>
                                              <el-option label="一级产品价格" value="01"></el-option>
                                              <el-option label="二级产品价格" value="02"></el-option>
                                              <el-option label="三级产品价格" value="03"></el-option>
                                              <el-option label="分销商价格" value="05"></el-option>
                                            </el-select>
                                          </div>
                                        </div>
                                        <el-form-item label="主销售渠道" class="h-elformWrap-2 w-elformWrap other" prop="customerGroup3">
                                          <brselectlazy :multiple="true" category="sales_region"
                                                        :v="formLabelAlign1.bscUserInfoAgentSell.customerGroup3"
                                                        v-model="formLabelAlign1.bscUserInfoAgentSell.customerGroup3"
                                                        :clearable="true"
                                                        disabled/>
                                        </el-form-item>
                                      </div>

                                    </el-form-item>
                                    <el-form-item label="客户分配账户组" class="h-elformWrap-2" prop="accountDistributeGroup" style="margin-left: 30px">
                                        <el-select disabled placeholder=""
                                                   :class="{'ljjSelectdisabled':true}"
                                                v-model="formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup">
                                          <el-option label="内销-海尔集团内（指国内市场所有海尔关联公司）-10" value="10"></el-option>
                                          <el-option label="内销-海尔集团外（指国内市场所有非海尔关联公司）-20" value="20"></el-option>
                                          <el-option label="外销-海尔集团内（指海外市场所有海尔关联公司）-30" value="30"></el-option>
                                          <el-option label="外销-海尔集团外（指海外市场非海尔关联公司）-40" value="40"></el-option>
                                          <el-option label="外销-合并范围内 -50" value="50"></el-option>
                                          <el-option label="内销-合并范围内 -60" value="60"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="签约性质" class="h-elformWrap-2" prop="customerGroup2">
                                        <el-select disabled placeholder=""
                                                   :class="{'ljjSelectdisabled':true}"
                                                v-model="formLabelAlign1.bscUserInfoAgentSell.customerGroup2">
                                            <el-option label="签约经销商" value="01"></el-option>
                                            <el-option label="非签约经销商" value="02"></el-option>
                                            <!--                                            <el-option label="直单用户" value="03"></el-option>-->
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="分销渠道" class="h-elformWrap-2" prop="distributionChannel">
                                        <brselectlazy category="YlSalesChannel_agent"
                                                      disabled placeholder=""
                                                      :class="{'ljjSelectdisabled':true}"
                                                      :v="formLabelAlign1.bscUserInfoAgentSell.distributionChannel"
                                                      v-model="formLabelAlign1.bscUserInfoAgentSell.distributionChannel"/>
                                    </el-form-item>
<!--                                    <el-form-item label="非主销售渠道" class="h-elformWrap-2 w-elformWrap other" prop="customerGroup3NotMain">

                                      <brselectlazy :multiple="true" category="sales_region"
                                                    :v="formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain"
                                                    v-model="formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain"
                                                    :clearable="true"
                                                    disabled/>
                                    </el-form-item>-->
                                    <el-form-item label="销售区域" class="h-elformWrap-2 w-elformWrap" prop="salesRegion">
                                        <brselectlazy :multiple="true" category="YlSalesArea_chanpin"
                                                      disabled placeholder=""
                                                      :class="{'ljjSelectdisabled':true}"
                                                      v-if="this.agentType != '3'"
                                                      :v="formLabelAlign1.bscUserInfoAgentSell.salesRegion"
                                                      v-model="formLabelAlign1.bscUserInfoAgentSell.salesRegion"/>
                                        <div v-if="this.agentType == '3'">
                                                        <SPAN v-if="this.isExpandAuthority != '1'">

                                                            <brselectlazy :multiple="true" category="YlSalesArea"
                                                                          disabled placeholder=""
                                                                          :class="{'ljjSelectdisabled':true}"
                                                                          :v="formLabelAlign1.bscUserInfoAgentSell.salesRegion"
                                                                          v-model="formLabelAlign1.bscUserInfoAgentSell.salesRegion"/>
                                                        </SPAN>
                                            <span v-else>

                                                            <brselectlazy :multiple="true" category="YlSalesArea_chanpin"
                                                                          disabled placeholder=""
                                                                          :class="{'ljjSelectdisabled':true}"
                                                                          :v="formLabelAlign1.bscUserInfoAgentSell.salesRegion"
                                                                          v-model="formLabelAlign1.bscUserInfoAgentSell.salesRegion"/>
                                                        </span>

                                        </div>

                                    </el-form-item>
                                </el-form>
                                <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right"
                                         ref="formLabelAlign12"
                                         :inline="true" :rules="rules1" class="demo-ruleForm h-formbLine h-formbLine1">
                                    <el-form-item label="公司代码" class="h-elformWrap-2 w-elformWrap" prop="companyCode">
                                        <brselectlazy :multiple="true" category="YlCompanyCode_agent"
                                                      disabled placeholder=""
                                                      :class="{'ljjSelectdisabled':true}"
                                                      @change="companyCodeChange($event)"
                                                      :v="formLabelAlign1.bscUserInfoAgentBasic.companyCode"
                                                      v-model="formLabelAlign1.bscUserInfoAgentBasic.companyCode"/>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bannerBox2">
                    <div class="h-row h-mrt1">
                        <div class="h-rowIn">
                            <div class="h-rowBox">
                                <div class="h-rowCon">
                                    <div class="h-pieceIn2">
                                        <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                        <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                            <h1>审核信息</h1>
                                        </div>
                                        <div class="h-pieceCon2 ">
                                            <div class="h-formLine weekplandetail11" style="position: relative;">
                                                <el-form :inline="true" :model="formLabelAlign1.bscUserInfoAgentSell">
                                                    <el-form-item label="审批意见" class="h-elformWrap-2 newBox"
                                                                style="width: 100%!important;">
                                                        <el-input
                                                                v-model="formLabelAlign1.bscUserInfoAgentSell.auditMind2"
                                                                placeholder="请输入"></el-input>
                                                    </el-form-item>
                                                </el-form>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div style="text-align: center;margin-top: 0.3rem">
                <el-button class="h-btn h-bBtn" :class="{'h-bgwhite':this.flag!=='2'&&this.flag!=='5'}"
                        @click="goBack">返回
                </el-button>
                <el-button class="h-btn h-bBtn h-bgred"
                        v-if="this.flag==='3'||this.flag==='4'"
                        @click="reject('formLabelAlign1')">驳回
                </el-button>
                <el-button class="h-btn h-bBtn h-bggreen" @click="update()"
                        v-if="this.flag==='3'||this.flag==='4'">通过
                </el-button>
                <el-button class="h-btn h-bBtn" @click="viewpress">
                    审批跟踪
                </el-button>

            </div>
            <viewhistory :visible.sync="showhistory" v-if="showhistory"
                        :id="instid"/>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService';
    import agentCopyService from "../../../api/loud/agent/agentCopyService";

    export default {
        data() {
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    if (this.check.checkpassword !== '') {
                        this.$refs.formLabelAlign1a.validateField('checkpassword');
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.formLabelAlign1.bscUserInfo.password) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            var validateCompany = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入公司名称'));
                } else if (value !== '') {
                    ss.SignService.checkCompany(value).then(response => {
                        this.companyData = response.obj.data;
                        console.log(response, '验证公司信息')
                        if (response.obj.status === '200') {
                            callback();
                            this.formLabelAlign1.bscUserInfoAgentBasic.companyAddress = this.companyData.address;
                            // this.formLabelAlign1.bscUserInfoAgentBasic.http = this.companyData.websites[0].web_url;
                            this.formLabelAlign1.bscUserInfoAgentBasic.companytype = this.companyData.econ_kind;
                            this.formLabelAlign1.bscUserInfoAgentBasic.founded = this.companyData.start_date;
                            this.formLabelAlign1.bscUserInfoAgentBasic.regmoney = this.companyData.regist_capi;
                            this.formLabelAlign1.bscUserInfoAgentBasic.legal = this.companyData.oper_name;
                            this.formLabelAlign1.bscUserInfoAgentBasic.business = this.companyData.scope;
                            this.formLabelAlign1.bscUserInfoAgentBasic.taxCode = this.companyData.credit_no;
                            this.formLabelAlign1.bscUserInfoAgentBasic.streetRoom = this.companyData.address;
                            this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber = this.companyData.contact.telephone;
                        } else {
                            callback(new Error('请输入正确的公司名称!'));
                        }
                    })

                }
            };
            return {
                haveThree6840:false,
                isShowAllSelect:false,//判断是否展示全部群连并checkout
                value1: true,
                value2: false,
                ctLevel: '',
                ND4Level: '',
                ND5Level: '',
                ND6Level: '',
                NA9Level: '',
                ct: true,
                ND4: true,
                ND5: true,
                ND6: true,
                NA9: true,
                isCt:false,
                isND4:false,
                isND5:false,
                isNA9:false,
                checkedlevels: [],
                levels: ['传统产品', 'U血液', 'U疫苗'],
                checkAll: false,
                isIndeterminate: true,
                have6858: false,
                have6840: false,
                have6854: false,
                showhistory: false,
                instid: null,
                showtime: false,
                companyData: null,
                showflag: false,
                have: false,
                have2: false,
                have3: false,
                isZhiDan: false,
                isBlood:false,
                isExpandAuthority:false,
                options: [],
                value: [],
                listSelect: [],
                addli: [],
                lianqunList:[],
                lianqunListCt:[],
                loadingSelect: false,
                states: [],
                isShowMassage: true,
                radio: '国内客户',
                fileShowFlag: false,
                uploadflag: true,
                delflag: true,
                refid: this.$util.getUuid(),
                fileList:[],
                fieldList:[
                  {name:'医疗创新领域',code:'L1'},
                  {name:'生命科学领域',code:'L2'}
                ],
                qudaoL1:[],
                qudaoL2:[],
                qudaoND5:[{code:'002',name:'医疗'}
                  ,{code:'003',name:'血站'}
                  ,{code:'010',name:'输血科'}
                ],
                qudaoND5List:[],
                loading: false,
                ind: null,
                index: ['a', 'b', 'c', 'd', 'e', 'f', 'h'],
                list: ["我是经销商", "我是供应商"],
                indx: 0,
                formLabelAlign1: {
                    bscUserInfoAgentBasic: {
                        usercode: null,
                        customerNumber: null,
                        accountGroup: null, // 科目组 , 配置项 , 调接口参数: YlCustomerAccountGroup , 字段输入限制:  0210 集团内客户 0260 海外客户 0280 国内客户 根据客户实际情况传入科目组代码  , 特殊限制:   付款条件销售平台更改
                        customerName1: '', // 客户全称1 ,  ,   , 字段输入限制: 客户全名。国内客户要求与证件注册的名称相同 , 特殊限制:   更改账期接口（公司销售视图付款条件字段）
                        customerTitle: null, // 客户标题 ,  ,   , 字段输入限制:  公司 先生 女士 先生和夫人 一般公司类客户数据，可以默认传入“公司”  ,
                        searchTerm: null, // 搜索项 ,  ,   ,   ,
                        postalCode: null, // 邮政编码 ,  ,   ,   ,
                        country: null, // 国家代码 , 配置项 , 调接口参数: YlCountry , 字段输入限制: 传入国家的代码，在list中选择 ,
                        region: null, // 地区 , 配置项 , 调接口参数: YlRegion , 字段输入限制: 传入地区的代码，在国家代码下的list中选择 ,
                        cityStreetRoom: '', // 城市 ,  ,   , 字段输入限制: 客户所在的城市中文名 ,
                        streetRoom: null, // 街道 ,  ,   , 字段输入限制: 客户证件上的注册地址 ,
                        phoneNumber: null, // 电话 ,  ,   , 字段输入限制: 客户证件上注册的电话，开发票使用 , 特殊限制: 最多16位
                        language: null, // 语言代码 , 配置项 , 调接口参数: YlLanguageType , 字段输入限制: 默认传入“ZH” ,
                        faxNumber: null, // 传真 ,  ,   ,   , 特殊限制: 最多16位
                        contactMobilePhone: null, // 移动电话 ,  ,   ,   , 特殊限制: 最多16位
                        companyCodeGeneral: null, // 公司代码(记录0210账户组下客户公司对照关系) , 配置项 , 调接口参数: CompanyCode , 字段输入限制: 当建立集团内客户时，此字段不能为空，需传入集团4位公司代码 ,
                        companyCode: null, // 公司代码 , 是否必填: 是 , 是否配置项: 是 , 值集代码: YlCompanyCode , 注释:
                        taxCode: null, // 纳税人登记号 ,  ,   , 字段输入限制: 客户证件注册的统一信用代码，开发票使用 ,
                        name1: null, // 联系人名称 ,  ,   , 字段输入限制: 客户方联系人的名字 ,
                        phoneNumber1: null, // 联系人电话1 ,  ,   , 字段输入限制: 客户方联系人的电话 , 特殊限制: 最多16位
                        companyAddress: null, // 公司地址名 ,  ,   ,   ,
                        contactCity: null, // 联系人城市 ,  ,   ,   ,
                        appellation: null, // 称谓 ,  ,   , 字段输入限制:  女士 先生  ,
                        partnerFlagSp: null, // 是否有售达方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
                        partnerFlagSh: null, // 是否有送达方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
                        partnerFlagBp: null, // 是否有开票方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
                        partnerFlagPy: null, // 是否有付款方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
                        cucode: null, //创建人编码
                        cuname: null, //创建人名称
                        cdate: null, //创建时间
                        lucode: null, //修改人编码
                        ldate: null, //最后更新时间
                        delflag: null, //可用标志。1：可用，0：删除标志
                        scale: null, //纳税人规模  0：小规模经营者   1：一般纳税人
                        http: null, //公司网址
                        companytype: null, //公司性质
                        founded: null, //成立时间
                        regmoney: null, //注册资本
                        legal: null, //法人姓名
                        introduce: null, //公司简介
                        business: null, //主营
                        achievement: null, //业绩
                        resource: null, //资源
                        email: null, //公司邮箱
                        remark: null,//备注
                        agentLevel:null,
                        oneLevelAgent:null,
                        oneLevelAgentName:null,
                        contractId:null,//经销商签约合同
                    },
                    bscUserInfoAgentBank: {
                        usercode: null, //公司编码
                        accountHolderName: null, // 银行帐户 ,  ,   , 字段输入限制: 开户许可证上的银行账号 ,
                        bankCountry: null, // 银行所属国家 , 配置项 , 调接口参数: YlCountry , 字段输入限制: 从国家列表中选择 ,
                        bankBranchCode: null, // 银行码 , 配置项 , 调接口参数: 从MDM开放的银行接口中选择 , 字段输入限制: 从MDM开放的银行接口中选择 ,
                        cucode: null, //创建人编码
                        cuname: null, //创建人名称
                        cdate: null, //创建时间
                        lucode: null, //修改人编码
                        ldate: null, //最后更新时间
                        delflag: null, //可用标志。1：可用，0：删除标志
                        vatCode: null, //VAT税号
                        bankName: null //银行名称
                    },
                    bscUserInfoAgentSell: {
                        usercode: null, //公司编码
                        distributionChannel: null, // 分销渠道 , 配置项 , 调接口参数: YlSalesChannel ,   ,
                        division: null, // 产品组 , 配置项 , 调接口参数: YLProductGroup , 字段输入限制: 默认00 ,
                        salesGroup: null, // 销售组织 , 配置项 , 调接口参数: YLSalesOrganization ,   ,
                        salesRegion: null, // 销售地区 , 配置项 , 调接口参数: YlSalesArea ,   ,
                        customerGroup: null, // 客户组(经销商级别) , 配置项 , 调接口参数: YlCustomerGroup , 字段输入限制: 内销必填 ,
                        currencyCode: null, // 货币代码 , 配置项 , 调接口参数: YlCurrency ,   ,
                        customerPricingProccess: null, // 客户定价过程 , 配置项 , 调接口参数: 默认传1 , 字段输入限制: 默认传1 ,
                        customerSummaryGroup: null, // 客户统计组 , 配置项 , 调接口参数: 默认传1 , 字段输入限制: 默认传1 ,
                        shipCondition: null, // 装运条件 , 配置项 , 调接口参数: 默认传01 , 字段输入限制: 默认传01 ,
                        shipPlant: null, // 交货工厂 , 配置项 , 调接口参数: YlPLPlantCode ,   ,
                        accountDistributeGroup: null, // 客户组的帐户分配 , 配置项 , 调接口参数: YlAccountDistributeGroup ,   ,
                        custTaxCategory: null, // 客户的税分类 , 配置项 , 调接口参数: 默认传1 , 字段输入限制: 默认传1 ,
                        paymentTerms1: null, // 付款条件-未包含在最近模板 , 配置项 , 调接口参数: YlPayTerm , 字段输入限制: 默认传0000 ,
                        podRelation: null, // 与 POD 处理相关 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
                        orderPossibility: null, // 订单可能性 ,  ,   ,   ,
                        intCommercialTerms: null, // 国际贸易条件 , 配置项 , 调接口参数: YlCommercialTerms , 字段输入限制: 外销必填 ,
                        intCommercialTerms2: null, // 国际贸易条件(部分2) ,  ,   , 字段输入限制: 外销必填 ,
                        fullDelivery: null, // 全部交货 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
                        partDelivery: null, // 每个项目允许的部分交货最大数 ,  ,   , 字段输入限制: 默认传9 ,
                        orderComposeIdentif: null, // 订单组合标识 ,  ,   , 字段输入限制: 传X或空  默认传X ,
                        customerGroup1: null, // 客户组 1(开票类型) , 配置项 , 调接口参数: YlCustomerGroup1 , 字段输入限制: 内销必填 ,
                        customerGroup2: null, // 客户组 2(经销商类型) , 配置项 , 调接口参数: YlCustomerGroup2 , 字段输入限制: 内销必填 ,
                        customerGroup3: null, // 客户组 3(渠道类型) , 配置项 , 调接口参数: YlCustomerGroup3 , 字段输入限制: 内销必填 ,
                        rebate: null, // 回扣 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
                        closeRoundingOff: null, // 关闭舍入 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
                        permit: null, //资质标识 1二级 2三级
                        cucode: null, //创建人编码
                        cuname: null, //创建人名称
                        cdate: null, //创建时间
                        lucode: null, //修改人编码
                        ldate: null, //最后更新时间
                        delflag: null, //可用标志。1：可用，0：删除标志
                        customerAssignGroup: null, //客户分配账户组: 10内销-集团内 20内销-集团外
                        auditMind1: null, //审核意见
                        auditMind2: null, //审核意见
                        haveThree6840:'',
                        licenseNumber:'',
                        customerGroup3NotMain:'',
                    },
                    bscUserInfoAgentCompany: {
                        usercode: null, //公司编码
                        companyCode: null, // 公司代码 , 配置项 , 调接口参数: YlCompanyCode ,   ,
                        hq: null, // 总部 ,  ,   ,   ,
                        reconcileAccount: null, // 统驭科目 , 配置项 , 调接口参数: YLReconcileAccount , 字段输入限制:  0230、0260、0280账户组默认1122002000 0210默认1122001000  ,
                        sequenceNo: null, // 排序码 , 配置项 , 调接口参数: YlOrderCode , 字段输入限制: 默认001 ,
                        paymentTerm: null, // 付款条款 , 配置项 , 调接口参数: YlPayTerm , 字段输入限制: 默认0000 ,
                        cucode: null, //创建人编码
                        cuname: null, //创建人名称
                        cdate: null, //创建时间
                        lucode: null, //修改人编码
                        ldate: null, //最后更新时间
                        delflag: null, //可用标志。1：可用，0：删除标志
                        mailreceiver: null, //邮寄接收人
                        receiverphone: null, //接收人电话
                        mailaddress: null, //邮寄地址
                    },
                    bscUserInfo: {
                        usercode: null, //员工编码/公司编码
                        password: '', //密码
                        usertype: null, //用户类别: 0-内部员工  1-经销商  2-供应商
                        username: '', //公司名称/员工姓名username
                        email: null, //邮箱
                        phone: null, //联系人电话
                        deptcode: null, //所属部门编码deptcode  公司用户为空
                        userdept: null, //用户详细部门userdept  公司用户为空
                        deptname: null, //部门名称deptname  公司用户为空
                        firstline: null, //一线经理firstline  公司用户为空
                        secondline: null, //二线经理secondline  公司用户为空
                        status: null, //用户状态: 0--禁用/冻结  1--正常  2--用户被删除
                        organization: null, //公司地址/住址机构
                        cdate: null, //创建时间
                        ldate: null, //更新时间
                        logintimes: null, //登录次数: 记录登录尝试失败次数，登录失败5次就将status改为禁止，联系运维解开
                        lastlogintime: null, //最后登录时间: 记录最后登录时间
                        accountdate: null, //账户有效期
                        area: null, //负责区域
                        lucode: null, //更新人编码
                        countrytype: null, //1- 国内  /  2- 国外   账户
                        fileId: null,
                        aaa: null,
                        taskid: null,
                    },
                    levelMap: {},
                    OperateType: null,
                    OPERATOR: null,
                    ctList: [{
                      field:'',//领域
                      channel:'',//渠道
                      channelList:[],//渠道
                      level:'',//等级
                      num: null,
                      lianqun:'',
                      lianqunList:[],//链群
                      cheakChannel: false,
                      cheakLevel: false,
                      showLq : false,
                    }],
                    ND5List: [{
                      channel:'',//渠道
                      level:'',//等级
                      num: null,
                      cheakLevel:false,
                      cheakChannel: false,
                    }],
                    ND4Channel:'',
                    NA9Channel:'',
                    cheakND4Level:false,
                    cheakNA9Level:false,
                    ND4List: [{
                      channel:'',//渠道
                      level:'',//等级
                      num: null,
                    }],
                    NA9List: [{
                      channel:'',//渠道
                      level:'',//等级
                      num: null,
                    }],

                },
                data: {},
                check: {
                    checkpassword: ''
                },
                rules: {
                    username: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    password: [{
                        required: true,
                        validator: validatePass,
                        trigger: 'blur'
                    },],
                    checkpassword: [{
                        required: true,
                        validator: validatePass2,
                        trigger: 'blur'
                    },],
                    customerName1: [{
                        required: true,
                        validator: validateCompany,
                        trigger: 'blur'
                    },],
                    // scale:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    companyAddress: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    // postalCode:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    // faxNumber:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    // http:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    // companytype:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    // founded:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    // regmoney:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    // legal:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    // introduce:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    // business:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    // achievement:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    // resource:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    // name1:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    phoneNumber1: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    // customerName1:
                    //     [
                    //         {required: true, validator: validateCompany, trigger: 'blur'},
                    //     ],
                    cityStreetRoom: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    streetRoom: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    phoneNumber: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    // postalCode:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    // name1:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    // phoneNumber1:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    // vatCode:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    bankBranchCode: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    bankName: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    accountHolderName: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    customerGroup1: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    // email:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    // mailreceiver:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    // receiverphone:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    // mailaddress:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    // upload1:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                },
                flag: '',
                modelList: [],
                agentType: 1,
                taskstatus: null,
            }
        },
        created() {
            console.log(this.$route.query, 'query')
            this.findAddress();
            this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
            this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122001000';
            this.formLabelAlign1.bscUserInfoAgentCompany.sequenceNo = '001';
            this.formLabelAlign1.bscUserInfoAgentCompany.paymentTerm = '0000';
            this.formLabelAlign1.bscUserInfoAgentSell.division = '00';
            this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
            this.formLabelAlign1.bscUserInfoAgentSell.customerPricingProccess = '1';
            this.formLabelAlign1.bscUserInfoAgentSell.customerSummaryGroup = '1';
            this.formLabelAlign1.bscUserInfoAgentSell.shipCondition = '01';
            this.formLabelAlign1.bscUserInfoAgentSell.custTaxCategory = '1';
            this.formLabelAlign1.bscUserInfoAgentSell.paymentTerms1 = '0000';
            this.formLabelAlign1.OperateType = 'CREATE';
            this.formLabelAlign1.OPERATOR = this._user.username;
            this.formLabelAlign1.bscUserInfoAgentBank.bankCountry = 'CN';
            this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagSp = '1';
            this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagBp = '1';
            this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagPy = '1';
            this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagSh = '1';
            var id = this.$route.query.ywid;
            this.formLabelAlign1.bscUserInfo.taskid = this.$route.query.taskid;
            this.instid = this.$route.query.instid;
            this.taskstatus = this.$route.query.taskstatus;
            agentCopyService.queryOne(id, "true").then(response => {
                console.log(response, 'response')
                this.queryLevelZc(response.obj.customergroupSell);
                this.queryLevelZcList(response.obj.customergroupSell);
                this.data = response.obj;
                if (response.obj.permitSell == 2) {
                    this.have2 = true;
                } else if (response.obj.permitSell == 3) {
                    this.have3 = true;
                } else if (response.obj.permitSell == 5) {
                    this.have3 = true;
                    this.have2 = true;
                }
                this.uploadflag = false;
                this.delflag = false;
                this.rules = {};
                if (this.taskstatus == '1') {
                    this.flag = '5';
                } else {
                    this.flag = '4';
                }
                this.refid = this.data.fileidInfo;
                this.fileShowFlag = true;
                this.checkDetail();
                console.log(this.refid, 'refid')
                // if (response.obj.customerassigngroupSell === '0280' && response.obj.agentTypeBas == '1') {
                if (response.obj.agentTypeBas == '1') {
                    this.radio = '国内客户';
                    this.agentType = 2;
                // } else if (response.obj.customerassigngroupSell === '0210' && response.obj.agentTypeBas == '2') {
                } else if (response.obj.agentTypeBas == '2') {
                    this.radio = '上海直销';
                    this.agentType = 1;
                } else if (response.obj.customerassigngroupSell === '0260' || response.obj.agentTypeBas == '3') {
                    this.radio = '海外客户';
                    this.agentType = 3;
                    this.isShowMassage = false;
                }
            })
        },
        methods: {
            findAddress() {
                ss.SignService.selectAddress().then(response => {
                    this.addli = response;
                })
            },
          queryLevelZc(v) {
                agentCopyService.queryLevelZc(v).then(response => {
                    console.log(response, 'levelmap')
                    if (response.ct != undefined) {
                        this.checkedlevels.push("传统产品");
                        this.ctLevel = response.ct;
                        this.ct = true;
                        this.formLabelAlign1.levelMap['ct'] = this.ctLevel;
                    }
                    if (response.ND4 != undefined) {
                        this.checkedlevels.push("U疫苗");
                        this.ND4Level = response.ND4;
                        this.ND4 = true;
                        this.formLabelAlign1.levelMap['ND4'] = this.ND4Level;
                    }
                    if (response.ND5 != undefined) {
                        this.checkedlevels.push("U血液");
                        this.ND5Level = response.ND5;
                        this.ND5 = true;
                        this.formLabelAlign1.levelMap['ND5'] = this.ND5Level;
                    }
                    if (response.ND9 != undefined) {
                        this.checkedlevels.push("U试剂");
                        this.ND6Level = response.ND9;
                        this.ND6 = true;
                        this.formLabelAlign1.levelMap['ND6'] = this.ND6Level;
                    }
                    if (response.NA9 != undefined) {
                      this.checkedlevels.push("航空温控");
                      this.NA9Level = response.NA9;
                      this.NA9 = true;
                      this.formLabelAlign1.levelMap['NA9'] = this.NA9Level;
                    }
                })
            },
            queryLevelZcList(v){
              agentCopyService.checkChangeLevelList(v).then(response => {
                console.log(response, 'levelmap11111111')
                if (response.ct != undefined) {
                  if(response.ct.length >= 1){
                    this.checkedlevels.push("传统产品");
                    this.formLabelAlign1.ctList = response.ct;
                    this.ct = true;
                    this.formLabelAlign1.levelMap['ct'] = this.ctLevel;
                    this.lianqunListCt.push("ct");
                    this.getLianqunTickct(this.lianqunListCt);
                  }
                }
                if (response.ND4 != undefined) {
                  this.checkedlevels.push("U疫苗");
                  this.ND4Level = response.ND4;
                  this.ND4 = true;
                  this.ND4Level = response.ND4.level;
                  this.formLabelAlign1.ND4Channel = response.ND4.channel;
                  this.formLabelAlign1.cheakND4Level = response.ND4.cheakChannel;
                  this.formLabelAlign1.levelMap['ND4'] = this.ND4Level;
                }
                if (response.ND5 != undefined) {
                  if(response.ND5.length >= 1){
                    this.checkedlevels.push("U血液");
                    this.ND5 = true;
                    this.formLabelAlign1.ND5List = response.ND5;
                    this.formLabelAlign1.levelMap['ND5'] = this.ND5Level;
                  }
                }
                if (response.NA9 != undefined) {
                  this.checkedlevels.push("航空温控");
                  this.NA9Level = response.NA9.level;
                  this.formLabelAlign1.NA9Channel = response.NA9.channel;
                  this.formLabelAlign1.cheakNA4Level = response.NA9.cheakChannel;
                  this.NA9 = true;
                  this.formLabelAlign1.levelMap['NA9'] = this.NA9Level;
                }
              })
            },
            ctSelect() {
                this.formLabelAlign1.levelMap['ct'] = this.ctLevel;
            },
            ND4Select() {
                this.formLabelAlign1.levelMap['ND4'] = this.ND4Level;
            },
            ND5Select() {
                this.formLabelAlign1.levelMap['ND5'] = this.ND5Level;
            },
            ND6Select() {
                this.formLabelAlign1.levelMap['ND6'] = this.ND6Level;
            },
            NA9Select() {
              this.formLabelAlign1.levelMap['NA9'] = this.NA9Level;
            },
            handleCheckAllChange(val) {
                console.log(val, '全选')
                if (val) {
                    this.ct = true;
                    this.ND4 = true;
                    this.ND5 = true;
                    this.ND6 = true;
                    this.NA9 = true;
                    this.formLabelAlign1.levelMap.ct = this.ctLevel;
                    this.formLabelAlign1.levelMap.ND4 = this.ND4Level;
                    this.formLabelAlign1.levelMap.ND5 = this.ND5Level;
                    this.formLabelAlign1.levelMap.ND6 = this.ND6Level;
                    this.formLabelAlign1.levelMap.NA9 = this.NA9Level;

                } else {
                    this.ct = false;
                    this.ND4 = false;
                    this.ND5 = false;
                    this.ND6 = false;
                    this.NA9 = false;
                    this.formLabelAlign1.levelMap = {};
                }
                this.checkedlevels = val ? this.levels : [];
                this.isIndeterminate = false;

            },
            handleCheckedCitiesChange(value) {
                console.log(value, '级别分类')
                this.ct = false;
                this.ND4 = false;
                this.ND5 = false;
                this.ND6 = false;
                this.NA9 = false;
                this.formLabelAlign1.levelMap = {};
                for (var i = 0; i < value.length; i++) {
                    if (value[i] == '传统产品') {
                        this.ct = true;
                        this.formLabelAlign1.levelMap['ct'] = this.ctLevel;
                    } else if (value[i] == 'U血液') {
                        this.ND5 = true;
                        this.formLabelAlign1.levelMap['ND5'] = this.ND5Level;
                    } else if (value[i] == 'U试剂') {
                        this.ND6 = true;
                        this.formLabelAlign1.levelMap['ND6'] = this.ND6Level;
                    } else if (value[i] == 'U疫苗') {
                        this.ND4 = true;
                        this.formLabelAlign1.levelMap['ND4'] = this.ND4Level;
                    } else if (value[i] == '航空温控') {
                        this.NA9 = true;
                        this.formLabelAlign1.levelMap['NA9'] = this.NA9Level;
                    }
                }
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.levels.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.levels.length;
            },
            viewpress() {
                this.showhistory = true;
            },
            handleIconClick() {
                this.showflag = true;
            },
            choseObj(obj) {
                console.log(obj)
                this.showflag = false;
                if (obj.zhenobj && obj.zhenobj.name) {
                    this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.zhenobj.name + ' ' + obj.addrdetail;
                } else {
                    this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.addrdetail;
                }
            },
            changeType(v) {
                if (v === '海外客户') {
                    this.agentType = 3;
                    this.isShowMassage = false;
                    this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0260';
                    this.formLabelAlign1.bscUserInfoAgentBasic.country = '';
                    this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
                    this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0260';
                } else if (v === '上海直销') {
                    this.agentType = 1;
                    this.isShowMassage = true;
                    // this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0210';
                    // this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
                    // this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122001000';
                    // this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
                    // this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0210';
                    this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0280';
                    this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
                    this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
                    this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
                    this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0280';
                } else if (v === '国内客户') {
                    this.agentType = 2;
                    this.isShowMassage = true;
                    this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0280';
                    this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
                    this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
                    this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
                    this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0280';
                }
            },
            //通过审批按钮功能
            update() {
                // this.formLabelAlign1.bscUserInfo.status = '4';
                // this.modelList.push(this.formLabelAlign1);
                // ss.SignService.update(this.modelList).then(response => {
                //     console.log(response)
                // })
                this.formLabelAlign1.bscUserInfo.aaa = 1;
                this.formLabelAlign1.ywid = this.$route.query.ywid;
                // this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms = 'CFR';
                // this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2 = 'CIF';
                console.log(this.formLabelAlign1, '提交时的数据')
                this.formLabelAlign1.bscUserInfoAgentBasic.isBlood = this.isBlood ? '1' : '0'
                agentCopyService.agentPass3(this.formLabelAlign1).then(rd => {
                    this.$msg.alerts("提交成功！", () => {
                        //刷新右上角的代办个数
                        this.$store.dispatch("searchTasktotal")
                        //跳转回系统的代办列表
                        this.$router.push({
                            path: '/personal/dealCenter'
                        })
                    })
                });

            },
            //驳回按钮功能
            reject(data) {
                if(this.formLabelAlign1.bscUserInfoAgentSell.auditMind2 && this.formLabelAlign1.bscUserInfoAgentSell.auditMind2 != ''){
                    this.formLabelAlign1.bscUserInfo.aaa = 2;
                    this.formLabelAlign1.ywid = this.$route.query.ywid;
                    this.formLabelAlign1.bscUserInfoAgentBasic.isBlood = this.isBlood ? '1' : '0'
                    agentCopyService.agentPass3(this.formLabelAlign1).then(rd => {
                        if (rd.f && rd.f == true) {
                            this.$msg.msgs("审批成功！");
                            var defaultpage = this._user.defaultpage;
                            this.$router.push({
                                path: defaultpage
                            });
                        }
                    })
                } else {
                    this.$msg.msge('请输入审批意见！')
                }

                // this.formLabelAlign1.bscUserInfo.status = '5';
            },
            //经销商查看功能对应展示数据功能
            checkDetail() {
                this.formLabelAlign1.bscUserInfo.usercode = this.data.usercodeInfo
                this.formLabelAlign1.bscUserInfoAgentBasic.usercode = this.data.usercodeBas
                this.formLabelAlign1.bscUserInfoAgentBank.usercode = this.data.usercodeBank
                this.formLabelAlign1.bscUserInfoAgentCompany.usercode = this.data.usercodeCom
                this.formLabelAlign1.bscUserInfoAgentSell.usercode = this.data.usercodeSell

                this.formLabelAlign1.bscUserInfo.username = this.data.usernameInfo
                this.formLabelAlign1.bscUserInfo.password = this.data.passwordInfo
                this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = this.data.customername1Bas
                if (this.data.scaleBas !== undefined) {
                    this.formLabelAlign1.bscUserInfoAgentBasic.scale = this.data.scaleBas.toString()
                }
                this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = this.data.iszhidanBas
                this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority  = this.data.isExpandAuthorityBas
                this.formLabelAlign1.bscUserInfoAgentBasic.agentType = this.data.agentTypeBas
                if (this.data.iszhidanBas == 1) {
                    this.isZhiDan = true;
                }
                if(this.data.isExpandAuthorityBas == 1){
                    this.isExpandAuthority =true
                }
                if(this.data.isBloodBas == 1){
                    this.isBlood = true
                } else {
                    this.isBlood = false
                }
                this.formLabelAlign1.bscUserInfoAgentBasic.companyAddress = this.data.companyaddressBas
                this.formLabelAlign1.bscUserInfoAgentBasic.postalCode = this.data.postalcodeBas
                this.formLabelAlign1.bscUserInfoAgentBasic.faxNumber = this.data.faxnumberBas
                this.formLabelAlign1.bscUserInfoAgentBasic.http = this.data.httpBas
                this.formLabelAlign1.bscUserInfoAgentBasic.companytype = this.data.companytypeBas
                this.formLabelAlign1.bscUserInfoAgentBasic.founded = this.data.foundedBas
                this.formLabelAlign1.bscUserInfoAgentBasic.regmoney = this.data.regmoneyBas
                this.formLabelAlign1.bscUserInfoAgentBasic.legal = this.data.legalBas
                this.formLabelAlign1.bscUserInfoAgentBasic.introduce = this.data.introduceBas
                this.formLabelAlign1.bscUserInfoAgentBasic.business = this.data.businessBas
                this.formLabelAlign1.bscUserInfoAgentBasic.achievement = this.data.achievementBas
                this.formLabelAlign1.bscUserInfoAgentBasic.resource = this.data.resourceBas
                this.formLabelAlign1.bscUserInfoAgentBasic.name1 = this.data.name1Bas
                this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1 = this.data.phonenumber1Bas
                this.formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone = this.data.contactmobilephoneBas
                this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = this.data.customername1Bas
                this.formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom = this.data.citystreetroomBas
                this.formLabelAlign1.bscUserInfoAgentBasic.streetRoom = this.data.streetroomBas
                this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber = this.data.phonenumberBas
                this.formLabelAlign1.bscUserInfoAgentBasic.postalCode = this.data.postalcodeBas
                this.formLabelAlign1.bscUserInfoAgentBasic.name1 = this.data.name1Bas
                this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1 = this.data.phonenumber1Bas
                this.formLabelAlign1.bscUserInfoAgentBasic.remark = this.data.remark
                this.formLabelAlign1.bscUserInfoAgentBasic.contractId = this.data.contractIdBas
                this.formLabelAlign1.bscUserInfoAgentBank.vatCode = this.data.vatcodeBank
                this.formLabelAlign1.bscUserInfoAgentBank.bankBranchCode = this.data.bankbranchcodeBank
                this.formLabelAlign1.bscUserInfoAgentBank.bankName = this.data.banknameBank
                this.formLabelAlign1.bscUserInfoAgentBank.accountHolderName = this.data.accountholdernameBank
              this.formLabelAlign1.bscUserInfoAgentSell.xkzEffectiveDate = this.data.xkzEffectiveDateSell
              this.formLabelAlign1.bscUserInfoAgentSell.yyzzEffectiveDate = this.data.yyzzEffectiveDateSell
                if (this.data.customergroup1Sell !== undefined) {
                    this.formLabelAlign1.bscUserInfoAgentSell.customerGroup1 = this.data.customergroup1Sell.toString()
                }
                this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel = this.data.agentLevelBas+""
                this.formLabelAlign1.bscUserInfoAgentBasic.email = this.data.emailBas
                this.formLabelAlign1.bscUserInfoAgentCompany.mailreceiver = this.data.mailreceiverCom
                this.formLabelAlign1.bscUserInfoAgentCompany.receiverphone = this.data.receiverphoneCom
                this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = this.data.mailaddressCom
                this.formLabelAlign1.bscUserInfoAgentSell.auditMind1 = this.data.auditmind1Sell
                this.formLabelAlign1.bscUserInfoAgentSell.customerGroup = this.data.customergroupSell
                this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = this.data.customerassigngroupSell
                this.formLabelAlign1.bscUserInfoAgentSell.customerGroup1 = this.data.customergroup1Sell
                this.formLabelAlign1.bscUserInfoAgentSell.customerGroup2 = this.data.customergroup2Sell
                this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = this.data.customergroup3Sell
                this.formLabelAlign1.bscUserInfoAgentSell.salesRegion = this.data.salesregionSell
                this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms = this.data.intcommercialtermsSell
                this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2 = this.data.intcommercialterms2Sell
                this.formLabelAlign1.bscUserInfoAgentSell.licenseNumber = this.data.licenseNumberSell
                this.formLabelAlign1.bscUserInfoAgentSell.haveThree6840Sell = this.data.haveThree6840Sell
                this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = this.data.customergroup3NotMainSell
                this.formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgentName = this.data.oneLevelAgentNameBas
                if(this.data.haveThree6840Sell == 1){
                    this.haveThree6840 = true
                }

                this.formLabelAlign1.bscUserInfoAgentBasic.contactCity = this.data.contactcityBas
                this.formLabelAlign1.bscUserInfoAgentBasic.appellation = this.data.appellationBas
                this.formLabelAlign1.bscUserInfoAgentBasic.country = this.data.countryBas
                this.formLabelAlign1.bscUserInfoAgentBasic.region = this.data.regionBas
                this.formLabelAlign1.bscUserInfoAgentBasic.companyCodeGeneral = this.data.companycodegeneralBas
                this.formLabelAlign1.bscUserInfoAgentBasic.companyCode = this.data.companycodeBas
                this.formLabelAlign1.bscUserInfoAgentBasic.taxCode = this.data.taxcodeBas
                this.formLabelAlign1.bscUserInfoAgentBasic.isFenxiao = this.data.isFenxiaoBas;
                this.formLabelAlign1.bscUserInfoAgentBasic.statusFenxiao = this.data.statusFenxiaoBas;
                this.formLabelAlign1.bscUserInfoAgentBasic.instidFenxiao = this.data.instidFenxiaoBas;
                this.formLabelAlign1.bscUserInfoAgentBasic.signingFenxiao = this.data.signingFenxiaoBas;
                this.formLabelAlign1.bscUserInfoAgentBasic.isIncrement = this.data.isIncrementBas;
                this.formLabelAlign1.bscUserInfoAgentBasic.incrementPt = this.data.incrementPtBas;
                this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = this.data.goodsCategoryBas
                this.formLabelAlign1.bscUserInfoAgentBank.bankCountry = this.data.bankcountryBank
                this.formLabelAlign1.bscUserInfoAgentSell.distributionChannel = this.data.distributionchannelSell
                this.formLabelAlign1.bscUserInfoAgentSell.salesGroup = this.data.salesgroupSell
                this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = this.data.currencycodeSell
                this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup = this.data.accountdistributegroupSell
                this.formLabelAlign1.bscUserInfoAgentSell.inEmail = this.data.inEmailSell
                this.$nextTick(function () {
                    let str = this.formLabelAlign1.bscUserInfoAgentBasic.companyCode;
                    if (str && str.split(',').indexOf('9390') >= 0) {
                        this.isShowAllSelect = true;//判断是否展示全部群连并checkbox
                    }
                })
                if (this.data.have6840Sell == 1) {
                    this.have6840 = true;
                }
                if (this.data.have6854Sell == 1) {
                    this.have6854 = true;
                }
                if (this.data.have6858Sell == 1) {
                    this.have6858 = true;
                }
              if(this.data.goodsCategoryBas != null && this.data.goodsCategoryBas != ''){
                let s = this.data.goodsCategoryBas;
                this.getLianqunTick(s)
                this.getLianquns(s)
              }

            },
            getLianquns(s){
              var m  = s.split(',');
              if(m.length<=0){
                this.lianqunList = ''
              }else {
                this.lianqunList = m
              }
            },
            goBack() {
                this.$router.push({
                    path: '/agent/agentCopy'
                })
            },
            go(index) {
                this.indx = index;
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${file.name}？`);

            },
            toLogin() {
                this.$router.push({
                    path: '/login'
                })
            },
            //公司代码改变回掉
            companyCodeChange(obj) {
                if (obj && obj.length > 0) {
                    let bool = false;
                    for (let item of obj) {
                        if (item.code == '9390') {
                            bool = true;
                        }
                        else{
                            this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = '';
                        }
                    }
                    if (bool) {
                        this.isShowAllSelect = true;//判断是否展示全部群连并checkbox
                        let s = this.formLabelAlign1.bscUserInfoAgentBasic.companyCode;
                        s = s.split(',');
                        if (s && s.length > 0 && s[s.length - 1] == '9390') {
                            ss.Dictservice.listbycategory('YlGoods_category').then(res => {
                                let arr = []
                                for (let item of res) {
                                    arr.push(item.code)
                                }
                                this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = arr.toString() || '';
                            })
                        }

                    } else {
                        this.isShowAllSelect = false;//判断是否展示全部群连并checkbox
                    }
                } else {
                    this.isShowAllSelect = false;//判断是否展示全部群连并checkbox
                    this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = '';
                }
            },
          fieldSelect(index){
            this.formLabelAlign1.ctList[index].channel = '';
            this.fields = [];
            for(var i=0;i<this.formLabelAlign1.ctList.length;i++){
              if(this.formLabelAlign1.ctList[i].field != null && this.formLabelAlign1.ctList[i].field != ''){
                this.fields.push(this.formLabelAlign1.ctList[i].field);
              }
            }
          },
          hasIncludeField(arr = [],item){
            return arr.includes(item)
          },
          getLianqunTick(query){
            if(query.indexOf("X06") != -1){
              this.isND4 = true;
            }else {
              this.isND4 = false;
            }
            if(query.indexOf("X05") != -1){
              this.isND5 = true;
            }else {
              this.isND5 = false;
            }
            if(query.indexOf("X12") != -1){
              this.isNA9 = true;
            }else {
              this.isNA9 = false;
            }
          },
          getLianqunTickct(query){
            console.log("lianquns",query);
            if(query.indexOf("ct") != -1){
              this.isCt = true;
            }else {
              this.isCt = false;
            }
          },
        },
        mounted() {
            this.flag = this.$route.query.index;
            console.log(this.flag, 'flag');
            if (this.flag === '2') {
                this.uploadflag = false;
                this.delflag = false;
                this.data = this.$route.query;
                this.rules = {};
                this.checkDetail();
            } else if (this.flag === '3') {
                this.uploadflag = false;
                this.delflag = false;
                this.data = this.$route.query;
                this.rules = {};
                this.checkDetail();
            }
        }
    }
</script>
<style scoped>
    .zhanghu {
        margin-bottom: 40px;
    }

    .imgBox {
        width: 100%;
    }

    .bannerBox {
        width: 100%;
        padding: 0.22rem 0.38rem 0 0.32rem;
        margin: 0 auto;
    }

    .whiteBox {
        width: 100%;
        padding: 0.22rem 0.26rem;
        background-color: #ffffff;
    }

    .titles {
        font-size: 0.16rem;
        color: #0e75e9;
        position: relative;
        padding-left: 9px;
        border-left: 0.05rem solid #0e75e9;
        font-weight: bold;
    }
    .h-formbLine .h-elformWrap-2 {
        padding-right: 0
    }
    .el-switch__label{

    }
</style>
<style >
    .passfollow {
        position: absolute;
        right: 0;
        bottom: 0.3rem;
        background-color: #2785e7;
        color: white;
    }

    /*    .signsign .h-formbLine .el-form-item__content .el-select {
        width: 100% !important;
    } */

    .zhanghu .h-formbLine .el-form-item__label,
    .signsign .h-formbLine .el-form-item__label {
        width: 44%;
    }

    .signsign .h-formbLine .h-elformWrap-3 .el-form-item__label {
        width: 12.5%;
    }

    .signsign .h-formbLine .h-elformWrap-3 {
        width: 100%;
        padding-right: 1rem;
    }

    .signsign .h-formbLine .h-elformWrap-3 .el-form-item__content {
        width: 87.5%;
    }

    .signsign .h-formbLine .h-elformWrap-1 .el-form-item__label {
        width: 0%;
    }

    .signsign .h-formbLine .h-elformWrap-1 .el-form-item__content {
        width: 100%;
    }

    .zhanghu .h-formbLine .el-form-item__content,
    .signsign .h-formbLine .el-form-item__content {
        width: 56%;
    }

    .zhanghu .h-formbLine .h-elformWrap-2,
    .signsign .h-formbLine .h-elformWrap-2 {
        width: 25%;
    }

    .weekplandetail11 .h-formbLine .el-form-item__label {
        width: 45%;
    }

    .weekplandetail11 .h-formbLine .el-form-item__content {
        width: 50%;
    }

    .bannerBox2 .el-form-item__content {
        width: 85%;
    }

    .bannerBox2 .el-input__inner {
        border: none;
        border-bottom: 1px solid #DCDFE6;
    }

    .w-elformWrap {
        width: 100% !important;
    }
    .w-elformWrap .el-form-item__label {
        width: 11% !important;
    }
    .w-elformWrap .el-form-item__content {
        width: 89% !important;
    }
    .qudoa{
      font-size: 0.18rem;
      color: #868686;
      line-height: 0.28rem;
      width: 0.5rem;
    }
    .foundation-box{
      font-size: 0.18rem;
      color: #868686;
      line-height: 0.28rem;
    }
</style>
